import { modelsWithLookupByBrand } from './model-lookup.js';
const removeExcessiveSpaces = (text) => text.replace(/\s{2,}/g, ' ').trim();
/**
 * Generates a title for a vehicle ad based on vehicle details
 *
 * @param model The model type (e.g., 'car-used', 'motorcycle')
 * @param adModelFields The fields definition from the model API
 * @param vehicleDetails The vehicle details to generate a title for
 * @returns The generated title or undefined if title can't be generated
 */
export const generateVehicleDetailsTitle = (_model, _adModelFields, vehicleDetails) => {
    if (!vehicleDetails)
        return undefined;
    if (!modelsWithLookupByBrand) {
        return undefined;
    }
    const setTitle = (makeText, modelText) => {
        const title = modelText ? `${makeText} ${modelText}` : makeText;
        const cleanTitle = removeExcessiveSpaces(title);
        if (vehicleDetails) {
            vehicleDetails.title = cleanTitle;
        }
        return cleanTitle;
    };
    if ('model_and_make' in vehicleDetails) {
        // Direct extraction from model_and_make.text
        if (vehicleDetails.model_and_make &&
            typeof vehicleDetails.model_and_make === 'object' &&
            'text' in vehicleDetails.model_and_make) {
            return vehicleDetails.model_and_make.text;
        }
        return undefined;
    }
    // Check if vehicleDetails has the expected structure for vehicle details
    if (vehicleDetails.make && typeof vehicleDetails.make === 'object' && 'text' in vehicleDetails.make) {
        const makeText = vehicleDetails.make.text;
        const modelText = vehicleDetails.model;
        if (makeText) {
            return setTitle(makeText, modelText);
        }
    }
    return undefined;
};
